App.GoogleRecaptchaComponent = Em.Component.extend
  env: Em.inject.service('environment')
  recaptchaId: null

  recaptchaService: Em.inject.service('recaptchaService')

  didInsertElement: ->
    @get('recaptchaService').retrieve()
    .then (recaptcha) =>
      id = recaptcha.render(@$().get(0), {
        'sitekey' : @get('env').recaptchaSitekey
        })
      @set('recaptchaId', id);
    false

